import { render, staticRenderFns } from "./AffilieFrance.vue?vue&type=template&id=52e6b45e&"
import script from "./AffilieFrance.vue?vue&type=script&lang=js&"
export * from "./AffilieFrance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports